var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Pipelines")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: {
                href: `/#/admin/integrations/pipelines/create/${_setup.organiationUnitId}`,
                type: "button",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-plus",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Create pipeline")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "card-group" }, [
        _c("div", { staticClass: "card bg-light" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h5", { staticClass: "card-title" }, [_vm._v("Pipelines")]),
            _vm._v(" "),
            _c("p", { staticClass: "card-text" }, [
              _vm._v(
                "Browse and manage your pipelines to import or export data."
              ),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  href: `/#/admin/integrations/pipelines/manage/${_setup.organiationUnitId}`,
                },
              },
              [_vm._v("All pipelines")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card bg-light" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h5", { staticClass: "card-title" }, [_vm._v("Connectors")]),
            _vm._v(" "),
            _c("p", { staticClass: "card-text" }, [
              _vm._v(
                "See and manage connectors that are used to read from or write to them data from datasets."
              ),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  href: `/#/admin/integrations/connectors/manage/${_setup.organiationUnitId}`,
                },
              },
              [_vm._v("All connectors")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card bg-light" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h5", { staticClass: "card-title" }, [_vm._v("Datasets")]),
            _vm._v(" "),
            _c("p", { staticClass: "card-text" }, [
              _vm._v(
                "Datasets are storing data for pipelines. Can be shared or pipline scoped"
              ),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  href: `/#/admin/integrations/datasets/manage/${_setup.organiationUnitId}`,
                },
              },
              [_vm._v("All datasets")]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex w-100 justify-content-between" }, [
        _c("h4", [_vm._v("Last runs")]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: `/#/admin/integrations/runs/manage/${_setup.organiationUnitId}`,
            },
          },
          [_vm._v("See all runs")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "list-group" },
        _vm._l(_setup.lastRuns, function (r) {
          return _c(
            "a",
            {
              key: r.RunId,
              staticClass: "list-group-item list-group-item-action",
              class: {
                "list-group-item-secondary": r.Queued,
                "list-group-item-primary": r.Running,
                "list-group-item-success": r.Succeed,
                "list-group-item-danger": (r.Failed || r.Aborted) && !r.Succeed,
              },
              attrs: {
                href: `/#/admin/integrations/runs/details/${_setup.organiationUnitId}/${r.RunId}`,
              },
            },
            [
              _c(
                "div",
                { staticClass: "d-flex w-100 justify-content-between" },
                [
                  _c("div", [
                    _c("h6", { staticClass: "mb-1" }, [
                      r.Running
                        ? _c("span", [_vm._v("[Running]")])
                        : r.Succeed
                        ? _c("span", [_vm._v("[Succeed]")])
                        : r.Failed
                        ? _c("span", [
                            _vm._v("[Failed(" + _vm._s(r.FailuresCount) + ")]"),
                          ])
                        : r.Aborted
                        ? _c("span", [_vm._v("[Aborted]")])
                        : _c("span", [_vm._v("[Queued]")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(r.PipelineName))]),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-1" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(r.Trigger) +
                          "\n                            "
                      ),
                      r.QueuedByName
                        ? _c("span", [_vm._v("by " + _vm._s(r.QueuedByName))])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(r.QueuedAtSinceNow) + " ago")]),
                      _vm._v(" "),
                      r.StartedAtSinceNow
                        ? _c("span", [
                            _vm._v(
                              "/ started " +
                                _vm._s(r.StartedAtSinceNow) +
                                " ago"
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      r.CompletedAtSinceNow
                        ? _c("span", [
                            _vm._v(
                              "/ completed " +
                                _vm._s(r.CompletedAtSinceNow) +
                                " ago"
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      r.FailedAtSinceNow
                        ? _c("span", [
                            _vm._v(
                              "/ failed " + _vm._s(r.FailedAtSinceNow) + " ago"
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      r.AbortedAtSinceNow
                        ? _c("span", [
                            _vm._v(
                              "/ aborted " +
                                _vm._s(r.AbortedAtSinceNow) +
                                " ago"
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-right" }, [
                    _c("small", [
                      _vm._v(_vm._s(r.LastActivityAtSinceNow) + " ago"),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("small", [_vm._v(_vm._s(r.Duration))]),
                  ]),
                ]
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("br"),
      _c("br"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }